function getCoords(coordinates = []) {
  let coords = { lat: 0, lng: 0 };
  if (coordinates.length) {
    const [points] = coordinates;

    if (points.length) {
      const [lng, lat] = points;
      coords = { lat, lng };
    }
  }

  return coords;
}

function filterLocations(results = []) {
  return results.reduce((acc, resObj) => {
    const {
      company: { name: displayName, logoUrlFull, id, identifier },
      location,
    } = resObj;

    const { geoLocation = {} } = location;
    const { coordinates = [] } = geoLocation;
    const { lat, lng } = getCoords(coordinates);

    const uid = btoa(`${lat},${lng}`);
    const idx = acc.findIndex((element) => element.id === uid);

    if (idx < 0) {
      return [
        ...acc,
        {
          companyId: id,
          identifier,
          displayName,
          id: uid,
          location,
          logoUrlFull,
          totalVacancies: 1,
        },
      ];
    }

    if (acc[idx]) {
      acc[idx] = { ...acc[idx], totalVacancies: acc[idx].totalVacancies + 1 };
    }

    return acc;
  }, []);
}

const normalizeMarkerDetails = (markerData) => {
  return filterLocations(markerData).map(
    ({
      id,
      displayName,
      totalVacancies,
      logoUrlFull,
      location,
      companyId,
      identifier,
    }) => {
      const {
        city,
        formattedAddress,
        geoLocation: { coordinates = [] },
      } = location;
      const coords = getCoords(coordinates);

      return {
        city,
        companyId,
        coords,
        displayName,
        formattedAddress,
        identifier,
        id,
        logoUrlFull,
        totalVacancies,
      };
    }
  );
};

export const normalizeVacancyPoint = (vacancy) => {
  const coords = getCoords(vacancy.location.geoLocation.coordinates);

  return {
    coords,
  };
};

export default normalizeMarkerDetails;
